// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { campaignsManifest } from './campaigns';
import { congressesAndMeetingsManifest } from './congresses-meetings';
import { membersManifest } from './members';
import { partyFinanceManifest } from './party-finance';
import { partyKnowledgeBaseManifest } from './party-knowledge-base';
import { partyProgrammeManifest } from './party-programme';
import { partyWorkManifest } from './party-work';

/** Група модулів «Партія та група» (PartyAndGroup): 7 модулів. */
export const partyAndGroupGroup: IModuleGroupManifest = {
  key: 'party-and-group',
  category: 'Party & Group',
  name: { en: 'Party & Group', uk: 'Партія та група' },
  sort: 17,
  modules: [campaignsManifest, congressesAndMeetingsManifest, membersManifest, partyFinanceManifest, partyKnowledgeBaseManifest, partyProgrammeManifest, partyWorkManifest],
};
